import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ['modal']

  initialize() {
    this.modal = new Modal(this.modalTarget)
    this.openModal = this.openModal.bind(this)
  }

  connect() {
    this.modalTarget.addEventListener(
      'turbo:before-fetch-response',
      this.openModal
    )
  }

  disconnect() {
    this.modalTarget.removeEventListener(
      'turbo:before-fetch-response',
      this.openModal
    )
  }

  openModal() {
    this.modal.show()
  }
}
